// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyResponseModel {
    static getAttributeTypeMap() {
        return SurveyResponseModel.attributeTypeMap;
    }
}
SurveyResponseModel.discriminator = undefined;
SurveyResponseModel.additionalProperties = false;
SurveyResponseModel.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=surveyResponseModel.js.map